import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import'rxjs/add/operator/toPromise';
export class SearchProjectsService {
private getUserDetailsEndPoint = "https://api.github.com/users/";
/**
 * @param {?} http
 */
constructor(private http: Http) { }
/**
 * @param {?} username
 * @return {?}
 */
getDetailsByUserName(username: string) : Promise<any> {
      let /** @type {?} */ url = `${this.getUserDetailsEndPoint}${username}`;
      return this.http.get(url)
      .toPromise()
      .then(response => /** @type {?} */(( response.json() as string)))
      .catch(this.handleError);
  }
/**
 * @param {?} username
 * @return {?}
 */
getRepositoriesDetailsByUserName(username: string) : Promise<any> {
        let /** @type {?} */ url = `${this.getUserDetailsEndPoint}${username}/repos`;
        return this.http.get(url)
        .toPromise()
        .then(response => response.json() )
        .catch(this.handleError);
  }
/**
 * @param {?} error
 * @return {?}
 */
private handleError (error: any): Promise<any> {
    let /** @type {?} */ errMsg = (error.message) ? error.message :
    error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    console.error(errMsg); // log to console
    return Promise.reject(errMsg);
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Http, },
];
}

function SearchProjectsService_tsickle_Closure_declarations() {
/** @type {?} */
SearchProjectsService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
SearchProjectsService.ctorParameters;
/** @type {?} */
SearchProjectsService.prototype.getUserDetailsEndPoint;
/** @type {?} */
SearchProjectsService.prototype.http;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
